import React, { useEffect } from 'react';
import *as mobx from 'mobx';
import BaseStateProxy from '../../stateProxy/BaseStateProxy';
import context from '../../context';
class MapStateProxy extends BaseStateProxy{
    init(){
        BaseStateProxy.prototype.init.call(this);
        // console.log(this);
        // mobx.extendObservable(
        //     this.state={
        //     }
        // );
        this.listeners.push(mobx.reaction(() => this.state.zoom,
            zoom => this.emit(this.MAP_SIZE_CHANGE,zoom)
        ));
        this.listeners.push(mobx.reaction(() => this.state.center,
            center => this.emit(this.MAP_CENTER_CHANGE,center)
        ));
    }
    setZoom(zoom){
        this.state.zoom = zoom;
    }
    getZoom(){
        return this.state.zoom;
    }
    setCenter(center){
        this.state.center = center;
    }
    getCenter(){
        return this.state.center;
    }
}
MapStateProxy.prototype.MAP_ZOOM_CHANGE = "map_zoom_change";
MapStateProxy.prototype.MAP_CENTER_CHANGE = "map_center_change";
export default MapStateProxy;